module.exports = __webpack_public_path__ + "img/node.2e7964e2.png";